var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#455154",
    d: "M8 20h8v-3q0-1.65-1.175-2.825T12 13t-2.825 1.175T8 17zm4-9q1.65 0 2.825-1.175T16 7V4H8v3q0 1.65 1.175 2.825T12 11M4 22v-2h2v-3q0-1.525.713-2.863A5.57 5.57 0 0 1 8.7 12a5.57 5.57 0 0 1-1.987-2.138A6 6 0 0 1 6 7V4H4V2h16v2h-2v3a6 6 0 0 1-.713 2.863A5.57 5.57 0 0 1 15.3 12a5.6 5.6 0 0 1 1.988 2.138Q18.001 15.476 18 17v3h2v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.b2fef7c5c9b76805256af1ae5ae5f904.svg";
export { ForwardRef as ReactComponent };